import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.518 7.688h.992l-.177 5.782h-.65zm.496 8.32a.63.63 0 0 1-.448-.178.62.62 0 0 1-.177-.436q0-.26.177-.425a.6.6 0 0 1 .448-.177q.26 0 .437.177.177.165.177.425a.62.62 0 0 1-.177.436.6.6 0 0 1-.437.177"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "8.475",
  stroke: "currentColor",
  "stroke-width": "1.05"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }